module.exports = __webpack_public_path__ + "img/1.a4cf201f.png";